//倒计时
function parseDateTime(dateTimeString) {
	let parts, dateParts, timeParts;
	if (dateTimeString.includes('-')) {
			// 使用 "-" 分割日期部分
			parts = dateTimeString.split(' ');
			dateParts = parts[0].split('-');
	} else if (dateTimeString.includes('/')) {
			// 使用 "/" 分割日期部分
			parts = dateTimeString.split(' ');
			dateParts = parts[0].split('/');
	} else {
			throw new Error('Unsupported date format');
	}
	
	// 分割时间部分
	timeParts = parts[1].split(':');
	
	// 创建 Date 对象
	return new Date(dateParts[2], dateParts[0] - 1, dateParts[1], timeParts[0], timeParts[1], timeParts[2]);
}

function lxfEndtime() {
	$(".lxftime").each(function () {
		var lxfday = $(this).attr("lxfday");//用来判断是否显示天数的变量
		var endtime = new Date($(this).attr("endtime")).getTime();//取结束日期(毫秒值)
		// let endTimeAttr = $(this).attr("endtime");
		// var endtime = parseDateTime(endTimeAttr).getTime();
		var nowtime = new Date().getTime();        //今天的日期(毫秒值)
		var youtime = endtime - nowtime;//还有多久(毫秒值)
		var seconds = youtime / 1000;
		var minutes = Math.floor(seconds / 60);
		var hours = Math.floor(minutes / 60);
		var days = Math.floor(hours / 24);
		var CDay = days;
		var CHour = hours % 24;
		var CMinute = minutes % 60;
		var CSecond = Math.floor(seconds % 60);//"%"是取余运算，可以理解为60进一后取余数，然后只要余数。
		if (CHour < 10) {
			CHour = "0" + CHour;
		}
		if (CMinute < 10) {
			CMinute = "0" + CMinute;
		}
		if (CSecond < 10) {
			CSecond = "0" + CSecond;
		}
		if (endtime <= nowtime) {
			$(this).html("Expired")//如果结束日期小于当前日期就提示过期啦
		} else {
			if ($(this).attr("lxfday") == "no") {
				$(this).html("<span>" + CDay + "</span>:<span>" + CHour + "</span>:<span>" + CMinute + "</span>:<span>" + CSecond + "</span>");          //输出没有天数的数据
			} else {
				$(this).html("<span>" + CDay + "</span>:<span>" + CHour + "</span>:<span>" + CMinute + "</span>:<span>" + CSecond + "</span>");          //输出有天数的数据
			}
		}
	});
	setTimeout("lxfEndtime()", 1000);
};
$(function () {
	lxfEndtime();

	//
	$('.nav li').click(function () {
		$(this).addClass('on').siblings().removeClass('on')
	})
	//
	var swiper1 = new Swiper(".layer4 .mySwiper", {
		slidesPerView: 3,
		spaceBetween: 30,
		autoplay: false,
        // centeredSlides: true,
       touchRatio: 2,
		// loop: true,
      freeMode: true,  // 启用自由模式
		navigation: {
			nextEl: ".layer4 .swiper-button-next",
			prevEl: ".layer4 .swiper-button-prev",
		},
		breakpoints: {
			320: {
				slidesPerView: 1.4,
				spaceBetween: 10,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});
	var swiper2 = new Swiper(".layer7 .mySwiper", {
		centeredSlides: true,
		slidesPerView: 4.4,
		spaceBetween: 30,
		autoplay: true,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1.2,
				spaceBetween: 10,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 4.4,
				spaceBetween: 30,
			},
		},
	});
	var swiper3 = new Swiper(".mobSwiper .mySwiper", {
		pagination: {
			el: ".mobSwiper .swiper-pagination",
			clickable: true,
		},
	});
});